export default "__VITE_ASSET__Diqneq7r__"